import {
  PATCH_LEAD,
  PATCH_LEAD_ERROR,
  PATCH_LEAD_ERROR_CLEAN,
  CLEAN_PATCH_LEAD_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function patchLeadReducer(state = initialState, action) {
  switch (action.type) {
    case PATCH_LEAD:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case PATCH_LEAD_ERROR:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case PATCH_LEAD_ERROR_CLEAN:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_PATCH_LEAD_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
